import React, { useEffect, useState } from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import Loader from "./Loader";

const SelectListValidators = ({title, url, handleChange, handleBlur}) => {
    const [options, setOptions] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setOptions(res.validators);
                setError(null);
            } else {
                setOptions(null);
                setError(res);
            }
            setLoading(false);
        });
    },[url]);

    const capitalize = (word) => {
        return word[0].toUpperCase() + word.slice(1);
    }
    
    return (
        <div>
            <label className="form-label" htmlFor={title}>Seleccionar {capitalize(title)}:</label>
            {loading && <Loader />}
            {error && <Loader />}
            <select name={title} id={title} className={`form-select p-inputtext p-component`} onChange={handleChange} onBlur={handleBlur} >
                <option value="">Elige un validador</option>
                {options && options.map((el) => <option value={el.usuarioid} key={el.usuarioid}>{el.nombre} {el.primer_apellido} {el.segundo_apellido} ({el.perfil}) - {el.asignadas} En Revisión </option>)}
            </select>
        </div>
    );  
}

export default SelectListValidators;